
export default function formMessage(form, messageBody) {
  const wrapper = document.createElement('DIV');

  wrapper.className = 'form-message';
  wrapper.innerHTML = messageBody;

  form.parentNode.replaceChild(wrapper, form);
};



// WEBPACK FOOTER //
// ./utility/form-message.js